<template>
  <b-modal
    :id="modalId"
    class="mc-modal"
    title="Konfirmasi"
    header-bg-variant="primary"
    size="md"
    centered
    @hide="handleCancel"
  >
    <p>
      <strong>{{ 'Ringkasan Temperatur DO Terpilih' }}</strong>
    </p>
    <p class="text-muted">
      {{ 'Dari DO yang Anda pilih, berikut temperatur terendah dan tertinggi yang terdeteksi:' }}
    </p>

    <div class="temperature-summary mb-3">
      <table class="temp-table">
        <thead>
          <tr>
            <th>{{ 'Terendah' }}</th>
            <th>{{ 'Tertinggi' }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="row-cell">
                <span class="fw-semibold">{{ formatDeliveryNumber(data?.min?.number) }}</span>
                <span>{{ data?.min?.temperature }}</span>
              </div>
            </td>
            <td>
              <div class="row-cell">
                <span class="fw-semibold">{{ formatDeliveryNumber(data?.max?.number) }}</span>
                <span>{{ data?.max?.temperature }}</span>
              </div>
            </td>
          </tr>
          <tr class="footer-row">
            <td colspan="2">
              <div class="row-cell">
                <span class="fw-semibold">Selisih</span>
                <span>{{ data?.difference }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="checkbox-wrapper mb-3">
      <input id="hideSummary" v-model="dontShowAgain" type="checkbox" class="checkbox-input" />
      <label for="hideSummary" class="checkbox-label">{{ 'Jangan tampilkan lagi' }}</label>
    </div>

    <p class="text-muted">
      {{ 'Lanjutkan proses pembuatan penugasan?' }}
    </p>

    <template #modal-footer>
      <McButton
        variant="secondary"
        class="me-2"
        :text="$t('global.action.cancel')"
        @click="closeModal"
      />
      <McButton
        variant="primary"
        type="submit"
        :text="$t('global.action.continue')"
        @click="handleCreateFO"
      />
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: { McButton },
  props: {
    data: {
      type: Object,
      default: null,
    },
    modalId: {
      type: String,
      default: 'modal-confirm-summary-temperature',
    },
  },
  data() {
    return {
      dontShowAgain: false,
      isCreateFO: false,
    }
  },
  methods: {
    formatDeliveryNumber(value) {
      if (!value) {
        return '-'
      }

      const match = String(value).match(/^Candidate-(.+)$/i)

      if (!match) {
        return value
      }

      return `${this.$t('global.delivery')}-${match[1]}`
    },
    handleCreateFO() {
      this.isCreateFO = true
      this.saveTemperaturePreference()
      this.closeModal()
      this.$emit('handleSubmit')
    },
    handleCancel(bvModalEvent) {
      if (bvModalEvent?.trigger === 'headerclose' || bvModalEvent?.trigger === 'cancel' || (bvModalEvent?.trigger === 'event' && !this.isCreateFO)) {
        this.$emit('handleCancel')
      }

      if (this.isCreateFO) {
        this.isCreateFO = false
      }
    },
    saveTemperaturePreference() {
      localStorage.setItem('hideTemperatureSummary', JSON.stringify(this.dontShowAgain))
    },
    closeModal() {
      this.$bvModal.hide(this.modalId)
    },
  },
}
</script>

<style scoped lang="scss">
.temperature-summary {
  margin-top: 1rem;
}

.temp-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 5px;
  overflow: hidden;
  font-size: 14px;
}

.temp-table th {
  background-color: $body-bg;
  color: $black;
  font-weight: 600;
  text-align: center;
  padding: 10px;
  border: 1px solid $teal-100;
}

.temp-table td {
  border: 1px solid $teal-100;
  padding: 8px 12px;
  color: $black;
}

.row-cell {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-row {
  background-color: $teal-100;
  font-weight: 600;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  color: $black;
  font-size: 12px;
}

.checkbox-input {
  width: 18px;
  height: 18px;
  accent-color: $blue-400;
  cursor: pointer;
}

.checkbox-label {
  cursor: pointer;
  margin: 0px;
}
</style>
